function regexEscape(str) {
  return str.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
}

export default function parameterize(string, seperator = '-') {
  const escapedSeperator = regexEscape(String(seperator))

  return string
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\-_]/g, seperator)
    .replace(new RegExp(`${escapedSeperator}{2,}`, 'g'), seperator)
    .replace(new RegExp(`^${escapedSeperator}|${escapedSeperator}$`, 'g'), '')
}
